import { api } from "./config";

// Packages currently sitting at `stationId` that are eligible to depart
// (i.e. their route has a next station from here that isn't END).
// `stationEligible: false` means this station has no outbound leg at all
// (e.g. SVK, which is scanned once and is already final) — the UI should
// show an empty-state instead of an empty grid.
export async function GetDepartureCandidates(stationId) {
  try {
    const response = await api().get("/departure-batch/candidates", {
      params: { stationId },
    });
    return response.data;
  } catch (error) {
    return {
      success: false,
      stationEligible: false,
      nextStations: [],
      data: [],
      message: error?.response?.data?.message || error.message,
    };
  }
}

export async function CreateDepartureBatch(fromStationId, packageIds) {
  try {
    const response = await api().post("/departure-batch", {
      fromStationId,
      packageIds,
    });
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error.message,
      skipped: error?.response?.data?.skipped,
    };
  }
}

// Packages that departed (in an active batch) toward `toStationId` but have
// not yet been scanned in there — the Scan page's "pending arrival" counter.
export async function GetPendingArrivals(toStationId) {
  try {
    const response = await api().get("/departure-batch/pending", {
      params: { toStationId },
    });
    return response.data;
  } catch (error) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message || error.message,
    };
  }
}

export async function GetDepartureBatchList(fromStationId) {
  try {
    const response = await api().get("/departure-batch/list", {
      params: { fromStationId },
    });
    return response.data;
  } catch (error) {
    return { success: false, data: [], message: error?.response?.data?.message || error.message };
  }
}

export async function GetDepartureBatchDetail(batchId) {
  try {
    const response = await api().get(`/departure-batch/${batchId}`);
    return response.data;
  } catch (error) {
    return { success: false, message: error?.response?.data?.message || error.message };
  }
}

// Housekeeping correction — item leaves the batch, package unaffected.
// `packageIds` omitted/empty clears every active item (the whole batch).
export async function ClearDepartureBatchItems(batchId, packageIds) {
  try {
    const response = await api().patch(`/departure-batch/${batchId}/clear`, { packageIds });
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error.message,
      skipped: error?.response?.data?.skipped,
    };
  }
}

// The shipment itself was cancelled (or another substantive reason it's not
// going out) — same mechanical effect as Clear, distinct audit trail.
// `packageIds` omitted/empty cancels every active item (the whole batch).
export async function CancelDepartureBatch(batchId, packageIds) {
  try {
    const response = await api().patch(`/departure-batch/${batchId}/cancel`, { packageIds });
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error.message,
      skipped: error?.response?.data?.skipped,
    };
  }
}
